import React from "react";
import ProbersTableRow from "./ProbersTableRow";

const ProbersTable = props => (
  <table className="total-time-charts">
    <tbody>
      {props.data.map((el, index) => (
        <ProbersTableRow
          key={index}
          data={el}
          max={props.max}
          protoType={props.protoType}
        />
      ))}
    </tbody>
  </table>
);

export default ProbersTable;
